import { ScrollReveal } from "@/components/base/ScrollAnimations";

interface Leader {
  role: string;
  name: string;
  designation: string;
}

interface CellLeadershipProps {
  chiefCatalyst: Leader;
  moderators: Leader[];
}

export default function CellLeadership({ chiefCatalyst, moderators }: CellLeadershipProps) {
  return (
    <section className="bg-tie-grey-light py-16 md:py-24">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <ScrollReveal>
            <div className="text-center mb-8 md:mb-12">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-tie-teal/10 mb-4 md:mb-5">
                <span className="text-xs font-semibold text-tie-teal uppercase tracking-wider">
                  / Cell Leadership
                </span>
              </div>
              <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-tie-text-primary leading-tight">
                Chief Catalyst & Moderators
              </h2>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
            {/* Chief Catalyst */}
            <ScrollReveal delay={100}>
              <div className="bg-white rounded-2xl p-6 md:p-8 border border-tie-grey-dark h-full">
                <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-tie-navy text-white text-xs font-semibold mb-5 md:mb-6">
                  <i className="ri-vip-crown-line" />
                  Chief Catalyst
                </div>
                <h3 className="text-lg md:text-xl font-bold text-tie-text-primary mb-2">
                  {chiefCatalyst.name}
                </h3>
                <p className="text-sm md:text-base text-tie-text-secondary leading-relaxed">
                  {chiefCatalyst.designation}
                </p>
              </div>
            </ScrollReveal>

            {/* Moderators */}
            <ScrollReveal delay={200}>
              <div className="bg-white rounded-2xl p-6 md:p-8 border border-tie-grey-dark h-full">
                <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-tie-teal text-white text-xs font-semibold mb-5 md:mb-6">
                  <i className="ri-user-voice-line" />
                  {moderators.length > 1 ? "Moderators" : "Moderator"}
                </div>
                <div className="space-y-5">
                  {moderators.map((mod) => (
                    <div key={mod.name}>
                      <h4 className="text-base md:text-lg font-bold text-tie-text-primary mb-1">
                        {mod.name}
                      </h4>
                      <p className="text-sm md:text-base text-tie-text-secondary leading-relaxed">
                        {mod.designation}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </ScrollReveal>
          </div>
        </div>
      </div>
    </section>
  );
}